<template>
  <nav class="px-8 py-4 mb-menu" v-if="$route.name !== 'Lanzamiento'">
    <img
      src="@/assets/images/hamburguer.png"
      alt="Shark Tank"
      class="ham"
      @click="openMenu = !openMenu"
    />
    <router-link to="/" class="img-logos">
      <img src="@/assets/images/top_logos.png" alt="Shark Tank" />
    </router-link>

    <ul class="mobile-menu" v-if="openMenu">
      <li class="mr-6 cursor-pointer">
        <div class="bar"></div>
        <router-link to="/concurso">El concurso</router-link>
      </li>
      <li class="mr-6 cursor-pointer">
        <div class="bar"></div>
        <router-link to="/">Capítulos</router-link>
      </li>
      <li class="mr-6 cursor-pointer">
        <div class="bar"></div>
        <router-link to="/emprendimientos">Emprendimientos</router-link>
      </li>
      <li class="mr-6 cursor-pointer">
        <div class="bar"></div>
        <router-link to="/premio">Premio</router-link>
      </li>
      <li class="mr-6 cursor-pointer">
        <div class="bar"></div>
        <router-link to="/jurado">Jurado</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      openMenu: false,
    };
  },
  methods: {
    currentRoute(route) {
      return this.$route.path === route;
    },
  },
  watch: {
    $route() {
      this.openMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
li::before {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    width: 70%;
    height: 3px;
    background: $dark-blue;
    bottom: -5px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

.mb-menu {
  display: none;

  @include phone {
    display: flex;
    justify-content: space-between;
  }
}

.ham {
  display: none;

  @include phone {
    display: block;
    width: 32px;
    height: 32px;
    cursor: pointer;
    margin-left: 1rem;
  }
}

.img-logos {
  width: 50%;
}

nav {
  display: flex;
  position: relative;
  background-color: $dark-blue;

  @include phone {
    justify-content: space-evenly;
    align-items: center;
    padding: 1rem 0;

    a {
      /* width: 280px; */
      img {
        width: 80%;
      }
    }
  }
}

ul.mobile-menu {
  @include phone {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 2rem;
    z-index: 10;
    background-color: $dark-blue;
    list-style: none;
    li {
      color: white;
      font-weight: bold;
      padding: 1rem 0;
      &:not(:last-child) {
        border-bottom: 1px solid lightgray;
      }

      a {
        color: white;
        text-decoration: none;
      }
    }
  }
}
</style>